import {clientAlderaan} from '../../core/stores';
import {QUERY_ALDERAAN_ACCOUNT_USERS} from '../../core/graphql/types';

export interface AccountUser {
  id: string;
  name?: string;
  lastName?: string;
  email: string;
  rule?: string;
  status?: string;
  isOwner: boolean;
}

export function QueryAccountUsers(
  accountId: string | number,
  search = '',
  first = 25,
): Promise<AccountUser[]> {
  return clientAlderaan
    .query({
      query: QUERY_ALDERAAN_ACCOUNT_USERS,
      variables: {accountId: String(accountId), search, first},
      fetchPolicy: 'network-only',
    })
    .then(({data}) => data?.accountUsers || [])
    .catch(() => []);
}
